import React, { useEffect, useState } from 'react';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import { Assignment } from '@material-ui/icons';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import moment from 'moment';

import { WithApp } from 'contexts/appContext';
import DetailKardex from './DetailKardex';
import { Toasty, useToasty } from 'hooks/Toasty';
import Button from 'components/CustomButtons/Button.js';
import { wsUpdate, wsFindBy, wsGet, wsCreate } from 'services/WService';
import { useLocation, useParams } from 'react-router-dom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const comboOutput = [
  { field: 'TSI', label: 'Interna' },
  { field: 'TSE', label: 'Externa' }
];

const comboEntry = [
  { field: 'A', label: 'Entrada1' },
  { field: 'B', label: 'Entrada2' }
];

export default WithApp(function Kardex(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const type = useQuery().get('type');
  const title = type === 'ET' ? 'entrada' : type === 'ETI' ? 'entrada de inventario' : type === 'OTI' ? 'salida de inventario' : 'salida';
  const entity = type === 'ET'  || type === 'ETI' ? 'logi/entry' : 'logi/output';
  const { id } = useParams();

  const defaultData = {
    TaxDate: moment().format('YYYY-MM-DD'),
    DocDate: moment().format('YYYY-MM-DD'),
    JrnlMemo: type === 'ET' || type === 'ETI' ? 'Entrada de mercadería' : 'Salida de mercadería',
    [type === 'ET' || type === 'ETI' ? 'U_SYP_TPOENTME' : 'U_SYP_MDTS']: type === 'ET' || type === 'ETI' ? 'A' : 'TSI',
    TypeInventory: type === 'ETI' ? 'Y' : type === 'OTI' ? 'Y' : 'N',
  };

  const [productSelecteds, setProductSelecteds] = useState([]);

  const [dataInitial, setDataInitial] = useState({});
  const [dataHeader, setDataHeader] = useState(defaultData);
  const [stateK, setStateK] = useState(false); // estado del kardex (state_migrate)

  const handleChangeHeader = (e) => {
    setDataHeader({ ...dataHeader, [e.target.name]: e.target.value });
  };

  const [warehouses, setWarehouses] = useState([]);

  async function listWarehouses() {
    let response = await wsFindBy('logi/warehouse');
    if (response.success) setWarehouses(response.data);
  }

  async function saveKardex() {
    let response = await wsCreate(entity, dataHeader);
    if (response.success) {
      window.history.replaceState('', '', `${response.data.id}?type=${type}`);
      getKardex(response.data.id);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function updateKardex() {
    let newData = {};
    for (let key in dataHeader) {
      if (dataInitial[key] != dataHeader[key]) {
        newData[key] = dataHeader[key];
      }
    }

    if (Object.keys(newData).length < 1) return;

    let response = await wsUpdate(entity, dataHeader.id, newData);
    if (response.success) {
      getKardex(response.data.id);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function getKardex(idKardex) {
    let response = await wsGet(entity, idKardex);
    if (response.success) {
      if (response.data.details?.length > 0) {
        response.data.details = response.data.details.map((item) => {
          return {
            ...item,
            quantity: item.Quantity,
            ItemName: item.Dscription,
            SalUnitMsr: item.unitMsr,
            NumInSale: item.NumPerMsr,
            unit_price: item.Price,
            total: parseFloat(item.Quantity || 0) * parseFloat(item.Price || 0)
          };
        });
      }
      setProductSelecteds(response.data.details?.reverse());
      setDataHeader(response.data);
      setDataInitial(response.data);
      setStateK(response.data.state_migrate === 'D' ? false : true);
    }
  }

  useEffect(() => {
    listWarehouses();
  }, []);

  useEffect(() => {
    if (id) getKardex(id);
  }, [id]);

  return (
    <>
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment style={{ color: 'white' }} />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Datos generales de {title}</h4>
        </CardHeader>
        <CardBody>
          <form
            id="formKardex"
            onSubmit={(e) => {
              e.preventDefault();
              if (dataHeader.id) {
                updateKardex();
              } else {
                saveKardex();
              }
            }}
          >
            <GridContainer>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Fecha contable"
                  type="date"
                  name="TaxDate"
                  fullWidth
                  margin="normal"
                  value={
                    moment(dataHeader.TaxDate).format('YYYY-MM-DD') ||
                    moment().format('YYYY-MM-DD') ||
                    ''
                  }
                  onChange={handleChangeHeader}
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Fecha documento"
                  type="date"
                  name="DocDate"
                  fullWidth
                  margin="normal"
                  value={
                    moment(dataHeader.DocDate).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD')
                  }
                  onChange={handleChangeHeader}
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Referencia"
                  fullWidth
                  name="Ref2"
                  margin="normal"
                  value={dataHeader.Ref2 || ''}
                  onChange={handleChangeHeader}
                  inputProps={{ maxLength: 11 }}
                  required
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <Autocomplete
                  key={dataHeader.logi_warehouse_id + warehouses}
                  options={warehouses}
                  disableClearable
                  defaultValue={
                    warehouses.find((item) => item.id == dataHeader.logi_warehouse_id) || undefined
                  }
                  getOptionLabel={(option) => option.WhsName}
                  disabled={stateK}
                  renderInput={(params) => (
                    <TextField {...params} label="Almacén" margin="normal" required />
                  )}
                  onChange={(e, item) => {
                    setDataHeader({
                      ...dataHeader,
                      logi_warehouse_id: item.id,
                      base_zone_description: item.base_zone_description
                    });
                  }}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Zona"
                  fullWidth
                  margin="normal"
                  value={dataHeader.base_zone_description || ''}
                  InputProps={{ readOnly: true }}
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  multiline
                  label="Comentario"
                  fullWidth
                  name="Comments"
                  margin="normal"
                  value={dataHeader.Comments || ''}
                  onChange={handleChangeHeader}
                  inputProps={{ maxLength: 127 }}
                  required
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Título"
                  fullWidth
                  name="JrnlMemo"
                  margin="normal"
                  value={dataHeader.JrnlMemo || ''}
                  onChange={handleChangeHeader}
                  inputProps={{ maxLength: 127 }}
                  required
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <Autocomplete
                  key={stateK + (type === 'ET' || type === 'ETI' ? comboEntry : comboOutput)}
                  options={type === 'ET' || type === 'ETI' ? comboEntry : comboOutput}
                  disableClearable
                  defaultValue={
                    (type === 'ET' || type === 'ETI' ? comboEntry : comboOutput).find(
                      (item) =>
                        item.field == dataHeader[type === 'ET' || type === 'ETI' ? 'U_SYP_TPOENTME' : 'U_SYP_MDTS']
                    ) || undefined
                  }
                  getOptionLabel={(option) => option.label}
                  disabled={stateK}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={`Tipo ${type === 'ET' || type === 'ETI' ? 'entrada' : 'salida'}`}
                      margin="normal"
                      required
                    />
                  )}
                  onChange={(e, item) => {
                    setDataHeader({
                      ...dataHeader,
                      [type === 'ET' || type === 'ETI' ? 'U_SYP_TPOENTME' : 'U_SYP_MDTS']: item.field
                    });
                  }}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Almacenero"
                  fullWidth
                  name="U_SYP_ALMACENERO"
                  margin="normal"
                  value={dataHeader.U_SYP_ALMACENERO || ''}
                  onChange={handleChangeHeader}
                  required
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Solicitante"
                  fullWidth
                  name="U_SYP_SOLICITANTE"
                  margin="normal"
                  value={dataHeader.U_SYP_SOLICITANTE || ''}
                  onChange={handleChangeHeader}
                  required
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={3}>
                <TextField
                  label="Motivo traslado"
                  fullWidth
                  name="U_SYP_MDMT"
                  margin="normal"
                  value={
                    dataHeader.U_SYP_MDMT === '22' ? 'Entrada por identificación errónea' : 
                      dataHeader.U_SYP_MDMT === '23' ? 'Salida por identificación errónea' :
                      dataHeader.U_SYP_MDMT || (type === 'ET' || type === 'ETI' ? 'Entrada por identificación errónea' : 'Salida por identificación errónea')
                  }
                  disabled
                />
              </GridItem>
            </GridContainer>

            {dataHeader.id ? (
              <AllowedGuard
                permission={
                  ConstantPermissions[type === 'ET' || type === 'ETI' ? 'LOGI_ENTRIES_UPDATE' : 'LOGI_OUTPUTS_UPDATE']
                }
              >
                <Button
                  type="submit"
                  color={props.themeContext.buttonColorWarning}
                  style={{ marginTop: '15px', float: 'right' }}
                  disabled={stateK}
                >
                  Actualizar
                </Button>
              </AllowedGuard>
            ) : (
              <AllowedGuard
                permission={
                  ConstantPermissions[type === 'ET' || type === 'ETI' ? 'LOGI_ENTRIES_STORE' : 'LOGI_OUTPUTS_STORE']
                }
              >
                <Button
                  type="submit"
                  color={props.themeContext.buttonColorSuccess}
                  style={{ marginTop: '15px', float: 'right' }}
                  disabled={stateK}
                >
                  Guardar
                </Button>
              </AllowedGuard>
            )}
          </form>
        </CardBody>
      </Card>

      {!!dataHeader.id ? (
        <DetailKardex
          warehouseId={dataHeader.logi_warehouse_id}
          type={type}
          entity={entity}
          dataHeader={dataHeader}
          productSelecteds={productSelecteds}
          setProductSelecteds={setProductSelecteds}
          showNotify={showNotify}
          getKardex={getKardex}
          stateK={stateK}
          setStateK={setStateK}
        />
      ) : undefined}
    </>
  );
});
